export default {"src":"/_next/static/media/carEmptyCircleBlue_40.dbd48c70.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};